//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum BranchSdkErrorType {
	None = "None",
	Error = "Error",
	TypeError = "TypeError",
	SyntaxError = "SyntaxError",
	AbortError = "AbortError",
	TimeoutError = "TimeoutError",
	SecurityError = "SecurityError",
	NetworkError = "NetworkError",
	QuotaExceededError = "QuotaExceededError",
	InvalidStateError = "InvalidStateError",
	Other = "Other"
}
